import { initGlobalState } from '@nio-fe/mate-qiankun';
import { collectLog } from '@/api/client/courtclerkClient';
import useMatestoreStore from '@/store/matestoreStore';
import MicroDialog from '@/components/micro-dialog';
import { MicroData } from '@/api/model/globalModel';
import { useGlobalRouteStore } from '@/store/globalRouteStore';
import { doLogout } from '@/utils/logout_action';
import useGlobalStore from '@/store/globalStore';
import { $alert } from '@nio-fe/lego';
import { inject } from 'vue';

const initialState = {};

export const actions = initGlobalState(initialState);

export default ({
  data: microData,
  userInfo,
  brandAdmins,
  brandAccounts,
  brandAuthorityMapping,
  availableBrands,
  sensorsInstance,
  globalData,
}: {
  data: any;
  router: any;
  userInfo: any;
  availableBrands: string[];
  brandAdmins: any[];
  brandAccounts: {
    nickname: string;
    avatar?: string;
    accountId: string;
    brand: string;
  }[];
  brandAuthorityMapping: Record<string, Record<string, boolean>>;
  sensorsInstance: any;
  globalData: any;
}) => {
  const mateStore = useMatestoreStore();
  const globalStore = useGlobalStore();
  const messageHandler = inject('messageHandler');
  const reload = () => {
    if (globalStore.isDoingLogout) {
      return;
    }
    mateStore.reloadMicroApp(microData.name);
  };

  /**
   * 加载微应用
   * */
  const loadMicroApp = async (microAppName: string, containerEl?: HTMLElement, activeAsComponent = true) => {
    return mateStore.activateMicroApp(microAppName, containerEl, activeAsComponent);
  }

  /**
   * 卸载微应用
   * */
  const unloadMicroApp = (microAppName: string) => {
    return mateStore.deactivateMicroApp(microAppName);
  }


  const logout = (content: string, alertOptions?: any) => {
    if (globalStore.isDoingLogout) {
      return;
    }
    globalStore.isDoingLogout = true;
    if (window?.__MATE_APP_OPTIONS?.iframeMode) {
      alert(content || '用户登录信息失效, 请重新登录.');
      return doLogout();
    } else {
      $alert(content || '用户登录信息失效, 请重新登录.', {
        okText: '知道了',
        ...(alertOptions || {}),
      })
        .then(() => {
          globalStore.isDoingLogout = false;
          return doLogout();
        })
        .finally(() => {
          globalStore.isDoingLogout = false;
        });
    }
  };
  const __DANGEROUS_LOGOUT_ACTION__ = () => {
    console.warn('you need be very carefully to call this logout action!!!');
    doLogout();
  };
  const props: any = {
    ...actions,
    base: microData.name,
    appCode: microData.appCode || microData.name,
    pageCode: microData.pageCode,
    activeRule: microData.path,
    appId: userInfo.appId,
    env: userInfo.env,
    token: globalData.accessToken,
    lang: globalData.lang,
    region: globalData.region,
    userInfo: userInfo,
    administrator: brandAdmins[0],
    availableBrands,
    brandAdmins,
    brandAccounts,
    brandAuthorityMapping,
    sensorsInstance,
    publicPath: `${window.location.origin}`,
    // 子应用跳转
    routerPush: (route: any) => {
      const store = useGlobalRouteStore();
      return store.push(route);
    },
    // 修改router meta，例如：im图标的消息数量
    setRouterMeta(name: string, option: Partial<MicroData>) {
      useMatestoreStore().updateMicro(name, { ...option });
    },
    // 搜索组件
    openSearch(params: any, callback?: Function) {
      MicroDialog.open({
        appName: 'search/appSearch',
      });
      // Vue.prototype.$openDialog.open('search/appSearch', params, callback)
    },
    // 日志
    collectLog(options: any) {
      try {
        collectLog({ module: microData.name, ...options });
      } catch (error) {
        console.error(error);
      }
    },
    reload,
    logout,
    loadMicroApp,
    unloadMicroApp,
    __DANGEROUS_INTERNAL_MSG_HANDLER: messageHandler,
    __DANGEROUS_LOGOUT_ACTION__,
  };

  if (props.appCode === 'im') {
    microData.isAppLoaded = false;
    let time = new Date().getTime();
    microData.isIsLoadedPromise = new Promise((resolve) => {
      const id = setInterval(() => {
        if (microData.isAppLoaded) {
          clearInterval(id);
          console.log('imAppLoaded', new Date().getTime() - time);
          // @ts-ignore
          resolve();
        }
      }, 100);
    });
    props.__mateImIsLoadedHook = () => {
      microData.isAppLoaded = true;
    };
  }

  const isWorkbenchMicro = microData.isWorkbenchMicro;
  if (isWorkbenchMicro) {
    props.core = {
      workbenchInfo: {},
      workbenchCombinationInfo: {},
      appId: 100498,
      env: userInfo.env,
      region: globalData.region,
      appInfo: {},
      base: microData.name,
      i18nConfig: null,
      currentLocale: 'zh_CN',
    };
  }

  return props;
};
